<template>
  <div class="order_block payment-block">
    <h3 class="title">Способы оплаты</h3>

    <div class="content">
      <standart-radio
          name="payment"
          :variants="paymentData.list"
          :current_variant="paymentData.current"
          @radio_change="payment_change($event)"
      >
      </standart-radio>
    </div>
  </div>
</template>

<script>

import StandartRadio from "@/components/share/StandartRadio";
export default {
  name: 'PaymentBlock',
  props: {
    paymentData : Object
  },
  components: {
    StandartRadio
  },
  data() {
    return{

    }
  },
  mounted() {

  },
  methods : {
    payment_change : function(value) {
      this.$emit("payment_change", value);
    }
  }
}
</script>

<style scoped>

/*MOBILE*/
@media (max-width: 1250px)
{
  .payment-block {
    gap: 18px;
  }
}
</style>



<style>

.payment-block {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.payment-block .standart-radio .title {
  display: none;
}

.payment-block .standart-radio .variants {
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 0px;
  gap: 12px;
}

</style>
